import React from 'react';
import { View, FlatList, RefreshControl, Alert } from 'react-native';
import { connect } from 'react-redux';

import get from "../../../api/methods/get";
import deleteMethod from '../../../api/methods/deleteMethod'

import Colors from "../../../constants/Colors";
import WritePostButton from "../../mural/WritePostButton";
import TopicPostRender from "./TopicPostRender";

import {DELETE_POST, MARK_SOLUTION, QUERY_POSTS} from "../api/forumEndpoints";
import {stringIsEmpty} from "../../../constants/StringChecker";
import post from "../../../api/methods/post";
import NavBar from "../../../components/NavBar";
import {
    CardTextArrow,
    ConfirmationDialogue,
    InformationDialogue,
    SpinnerControl,
    SpinnerDialogue
} from "../../../components";

class TopicScreen extends React.Component {

    state = {
        deletingPost: false,
        fetchingPosts: false,
        markingSolution: false,
        posts: [],

        userCreatedTopic: false,

        showMarkingSolutionSuccess: false,
        showMarkingSolutionConfirmation: false,
        selectedPostId: null,

        showDeleteConfirmation: false,
        postIdToDelete: null,
        showDeleteSuccess: false,
    }

    fetchPosts = async () => {
        if (this.state.fetchingPosts) return;
        this.setState({ fetchingPosts: true, posts: [] });

        try {

            const mainTopicData = this.props.location.state.topicData;
            const topicId = mainTopicData.topicId;

            const getResult = await get(QUERY_POSTS(topicId));
            const json = await getResult.json();

            if (mainTopicData.createdBy === this.props.userId)
                this.setState({ userCreatedTopic: true })

            this.setState({ posts: json.data.Items })

        } catch (e) {
            console.log(e);
        }

        this.setState({ fetchingPosts: false });
    }

    handleDeleteRequest = async (postId) => {

        if (this.state.deletingPost) return;
        this.setState({ deletingPost: true })

        try {

            const mainTopicData = this.props.location.state.topicData;
            const topicId = mainTopicData.topicId;

            let result = await deleteMethod(DELETE_POST(topicId, postId));

            await this.fetchPosts();

            this.setState({ showDeleteSuccess: true });

        } catch (e) {
            console.log(e);
        }

        this.setState({ deletingPost: false })
    }

    initiateDeleteRequest = (postId) => {
        this.setState({
            showDeleteConfirmation: true,
            postIdToDelete: postId,
        })
    }

    handleMarkSolution = async (postId) => {
        if (this.state.markingSolution) return;
        this.setState({ markingSolution: true })

        try {
            const mainTopicData = this.props.location.state.topicData;
            const payload = {
                topicId: mainTopicData.topicId,
                journeyId: mainTopicData.journeyId,
                postSolutionId: postId
            }

            const result = await post(MARK_SOLUTION, payload);
            await this.fetchPosts();

            this.setState({ showMarkingSolutionSuccess: true })

        } catch (e) {
            console.log(e);
        }

        this.setState({ markingSolution: false })
    }

    handleResponseClick = (postData) => {
        const mainTopicData = this.props.location.state.topicData;

        this.props.history.push("/forum/topic/answer", {
            topicId: mainTopicData.topicId,
            journeyId: mainTopicData.journeyId,
            answerToData: postData,
        })
    }

    componentDidMount() {
        this.fetchPosts();
    }

    render() {

        const mainTopicData = this.props.location.state.topicData;

        return (
            <NavBar title={"Tópico"}>

                <SpinnerDialogue
                    isModalVisible={this.state.markingSolution}
                    onClose={() => {}}
                    isFinished={!this.state.markingSolution}
                    titleProps={"Marcando post"}
                    messageProps={"Estamos marcando esse post como solução para o tópico!"}
                />

                <InformationDialogue
                    isModalVisible={this.state.showMarkingSolutionSuccess}
                    titleText={"Sucesso!"}
                    descriptionText={"Marcamos com sucesso essa resposta como melhor solução para este tópico! "}
                    onClose={() => this.setState({ showMarkingSolutionSuccess: false })}
                />

                <ConfirmationDialogue
                    isModalVisible={this.state.showMarkingSolutionConfirmation}
                    onClose={() => this.setState({ showMarkingSolutionConfirmation: false, selectedPostId: null })}
                    onConfirm={() => {
                        this.setState({
                            showMarkingSolutionConfirmation: false
                        })

                        this.handleMarkSolution(this.state.selectedPostId);
                    }}
                    titleText={"Confirmar"}
                    descriptionText={"Você confirma que quer marcar esta resposta como a melhor? É possível mudar para outra resposta depois."}
                />

                <ConfirmationDialogue
                    isModalVisible={this.state.showDeleteConfirmation}
                    onClose={() => this.setState({ showDeleteConfirmation: false, postIdToDelete: null, })}
                    onConfirm={() => {
                        this.setState({ showDeleteConfirmation: false })
                        this.handleDeleteRequest(this.state.postIdToDelete);
                    }}
                    descriptionText={"Você tem certeza que deseja deletar esse post?"}
                    titleText={"Confirmar exclusão"}
                />

                <SpinnerDialogue
                    isModalVisible={this.state.deletingPost}
                    onClose={() => {}}
                    isFinished={!this.state.deletingPost}
                    titleProps={"Excluindo"}
                    messageProps={"Estamos fazendo a exclusão do seu post!"}
                />

                <InformationDialogue
                    isModalVisible={this.state.showDeleteSuccess}
                    titleText={"Sucesso"}
                    descriptionText={"Seu post foi excluído com sucesso!"}
                    onClose={() => this.setState({ showDeleteSuccess: false })}
                />

                <SpinnerControl
                    isFetching={this.state.fetchingPosts}
                    text={"Carregando posts"}
                />

                {
                    this.state.fetchingPosts === false &&
                        <CardTextArrow
                            text={"Responder tópico"}
                            showArrow={true}
                            onPress={() => this.props.history.push('/forum/topic/answer', {
                                topicId: mainTopicData.topicId,
                                journeyId: mainTopicData.journeyId,
                                answerToData: null,
                            })}
                        />
                }

                <FlatList
                    contentContainerStyle={{ width: 600, marginTop: 32 }}
                    renderItem={({item, index}) => {
                        const isLast = index === this.state.posts.length - 1;

                        let answerToData = null;

                        if (stringIsEmpty(item.answerTo) === false) {
                            const postAnswerData = this.state.posts.find(p => {
                                if (p.postId === item.answerTo)
                                    return item;
                            });

                            answerToData = postAnswerData;
                        }

                        return (
                            <TopicPostRender
                                {...item}
                                data={item}
                                description={item.text}
                                isLast={isLast}
                                responseClick={this.handleResponseClick}
                                answerToData={answerToData}
                                currentUserId={this.props.userId}
                                initiateDeleteRequest={this.initiateDeleteRequest}
                                handleMarkSolution={(postId) => {
                                    this.setState({
                                        showMarkingSolutionConfirmation: true,
                                        selectedPostId: postId,
                                    })
                                }}
                                userCreatedTopic={this.state.userCreatedTopic}
                            />
                        )
                    }}
                    data={this.state.posts}
                    keyExtractor={item => item.postId.toString()}
                    refreshControl={
                        <RefreshControl
                            refreshing={this.state.fetchingPosts}
                            onRefresh={() => this.fetchPosts()}
                            colors={[Colors.spinnerColor]}
                            title={'Carregando respostas!'}
                        />
                    }
                />

                {/*<WritePostButton*/}
                {/*    imageSource={require('../../muralStack/img/pencilIcon.png')}*/}
                {/*    onPress={() => this.props.navigation.navigate("TopicAnswerScreen",*/}
                {/*        {*/}
                {/*            topicId: mainTopicData.topicId,*/}
                {/*            journeyId: mainTopicData.journeyId,*/}
                {/*            answerPostId: null,*/}
                {/*        })}*/}
                {/*/>*/}

            </NavBar>
        )
    }

}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
    }
}

export default connect(mapStateToProps)(TopicScreen);
